import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { TeacherCreateclassroomComponent } from '../teacher-createclassroom/teacher-createclassroom.component';
import { ClassroomManagementService } from '@edtech-ui/core/services/classroom-management-service/classroom-management.service';
import { Subscription, tap } from 'rxjs';
import { DeleteClassroomResponse } from '@edtech-ui/core/models/Classroom/delete-classroom';
import { ToastrService } from 'ngx-toastr';
import { GetClassroomByTeacher, GetClassroomByTeacherResponse } from '@edtech-ui/core/models/Classroom/get-classroomByTeacher';
import { DeleteDialogBoxComponent } from '../classroom/delete-dialog-box/delete-dialog-box.component';
import { ClassroomPostDialogBoxComponent } from '../classroom/classroom-post-dialog-box/classroom-post-dialog-box.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';

@Component({
	selector: 'app-teacher-classrooms',
	standalone: true,
	imports: [SharedModule, MatMenuModule, MatRadioModule],
	templateUrl: './teacher-classrooms.component.html',
	styleUrl: './teacher-classrooms.component.scss'
})
export class TeacherClassroomsComponent implements OnInit {

	searchQuery = '';
	_classroom: GetClassroomByTeacher[] = [];
	filteredClassrooms: GetClassroomByTeacher[] = [];
	isLoading: boolean = false;
	subscription = new Subscription();
	_totalCount: number = 0;
	userId: string | null = null;
	selectedFilter: string = 'All';
	loggedInUserId: string = '';

	constructor(private router: Router, private dialog: MatDialog,
		private _classroomService: ClassroomManagementService,
		private _toastr: ToastrService
	) {
		this.subscription.add(this._classroomService.reload$.pipe(tap(() => this.getClassroom())).subscribe());
	}

	ngOnInit(): void {
		this.getClassroom();
		this.loggedInUserId = localStorage.getItem('user_id') || '';
	}

	openCreateClassDialog() {
		this.dialog.open(TeacherCreateclassroomComponent, {
			data: { mode: 'create' }
		}).afterClosed().subscribe(result => {
			if (result) {
				this.getClassroom();
			}
		})
	}

	goToClassroomPage(classroomId: string | number) {
		this.router.navigate(['/teacher-dashboard/classroom-detail-page', classroomId, 'overview']);
	}

	getClassroom() {
		this.isLoading = true;
		const filterType = this.selectedFilter.toLowerCase();
		const page = 1;
		this.subscription.add(
			this._classroomService.getAllTeacherClassrooms(filterType, page).subscribe({
				next: (response: GetClassroomByTeacherResponse) => {
					this._classroom = response.Data.classrooms;
					this.filteredClassrooms = [...this._classroom];
					this.isLoading = false;
				},
				error: () => {
					this._toastr.error('Failed to fetch classrooms.');
					this.isLoading = false;
				}
			})
		);
	}

	deleteClassroom(id: number) {
		this._classroomService.deleteClassroom(id).subscribe({
			next: (response: DeleteClassroomResponse<null>) => {
				if (response.Success) {
					this._toastr.success(response.Message);
					this.getClassroom();
				}
			},
			error: () => {
				this._toastr.error('Failed to delete classroom.');
			}
		});
	}


	openEditDialog(classroom: any) {
		this.dialog.open(TeacherCreateclassroomComponent, {
			width: '500px',
			data: {
				mode: 'edit',
				classroom: classroom
			}
		}).afterClosed().subscribe(result => {
			if (result) {
				this.getClassroom();
			}
		});
	}

	onSearchQueryChange(query: string): void {
		const q = query.trim().toLowerCase();
		if (!q) {
			this._classroom = [...this.filteredClassrooms];
			return;
		}
		this._classroom = this.filteredClassrooms.filter(c =>
			c.name?.toLowerCase().includes(q) || c.subject?.toLowerCase().includes(q));
	}

	onDeleteDialogBox(id: number): void {
		const dialogRef = this.dialog.open(DeleteDialogBoxComponent, {
			panelClass: 'confirm-dialog'
		});
		dialogRef.afterClosed().subscribe(result => {
			if (result == true) {
				this.deleteClassroom(id);
			}
		});
	}

	openJoinDialogBox() {
		this.dialog.open(ClassroomPostDialogBoxComponent, {
			data: { mode: 'join classroom' }
		});
	}

	getFilterLabel(): string {
		switch (this.selectedFilter) {
			case 'created':
				return 'Created';
			case 'joined':
				return 'Joined';
			default:
				return 'All';
		}
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

}
